import { Component, OnInit } from '@angular/core';
import { TipPotvrdeOStrucnomUsavrsavanju } from './tip-potvrde-o-strucnom-usavrsavanju';
import { BaseModalContainer, ModalContainerService, ModalService, UserService } from 'yt-ng-framework';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'yt-tip-potvrde-o-strucnom-usavrsavanju',
  templateUrl: './tip-potvrde-o-strucnom-usavrsavanju.component.html'
})
export class TipPotvrdeOStrucnomUsavrsavanjuComponent extends BaseModalContainer<TipPotvrdeOStrucnomUsavrsavanju> implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<TipPotvrdeOStrucnomUsavrsavanju>,
    protected activatedRoute: ActivatedRoute,
    protected modalService: ModalService,
    protected userService: UserService
  ) {
    super(modalContainerService, activatedRoute, modalService, userService);
   }


   

  ngOnInit() {
  }

}
